<template>
    <div class="fs5-estimated-earns-card">
        <div class="fs5-earns-card-title" v-html="title"></div>
        <div class="fs5-earns-card-value" v-html="value"></div>
    </div>
</template>

<script>
    export default {
        name: "fs5-estimated-earns-card",
        props: {
            title: {
                default: 'Estimation (BRL)'
            },
            value: {
                default: '0,00'
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-estimated-earns-card{
        font: inherit;
        padding: 2em;
        min-height: 13.4em;

        border: 1px solid $fs5-color1;
        background-color: $fs5-color2;
        border-radius: 0.8em;
        text-align: center;

        .fs5-earns-card-title{
            font: inherit;
            color: $fs5-color9;
            font-size: 1.6em;
            line-height: 1.2;
            font-weight: 700;
            padding-bottom: 0.625em;
        }
        .fs5-earns-card-value{
            font: inherit;
            color: $fs5-color10;
            font-size: 3.6em;
            line-height: 1.2;
            font-weight: 800;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/tools/card/EstimatedEarnsCard.vue